import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassengerInformationComponent } from './passenger-information.component';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [PassengerInformationComponent],
  imports: [CommonModule, ButtonModule, StaticMsgModule],
  exports: [PassengerInformationComponent],
})
export class PassengerInformationModule {}
